import { z } from 'zod'

// Item schemas
export const itemSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  sku: z.string().optional(),
  ic: z.string().optional(),
  description: z.string().optional(),
  condition: z.enum(['new', 'used-good', 'used-fair', 'damaged']).optional(),
  quantity: z.number().min(0, 'Quantity must be non-negative'),
  target_price: z.number().min(0, 'Price must be non-negative'),
  cost: z.number().min(0, 'Cost must be non-negative'),
  category_id: z.string().min(1, 'Category is required'),
  location_id: z.string().min(1, 'Location is required'),
  tote_id: z.string().optional(),
  status: z.enum(['active', 'inactive', 'sold', 'returned']).default('active'),
})

export const itemUpdateSchema = itemSchema.partial()

export const itemSearchSchema = z.object({
  search: z.string().optional(),
  category: z.string().optional(),
  location: z.string().optional(),
  status: z.string().optional(),
  limit: z.number().min(1).max(100).default(20),
  offset: z.number().min(0).default(0),
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).default('desc'),
})

// Category schemas
export const categorySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
})

// Location schemas
export const locationSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional(),
})

// User schemas
export const userSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Invalid email address'),
  role: z.enum(['admin', 'user']).default('user'),
})

// Auth schemas
export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
})

// Export types
export type ItemUpdate = z.infer<typeof itemUpdateSchema>
export type ItemSearch = z.infer<typeof itemSearchSchema>
export type Category = z.infer<typeof categorySchema>
export type Location = z.infer<typeof locationSchema>
export type User = z.infer<typeof userSchema>
export type Login = z.infer<typeof loginSchema>
